/** Spanish Entrepreneurship Support Translations */
export const entrepreneurship = {
  entrepreneurship: {
    pageTitle: "Dimensión Apoyo al Emprendimiento",
    weightInFII: "peso en FII",
    heroSubtitle: "Empoderando a Jóvenes para Crear Empleos Sostenibles y Construir Riqueza (18-40 años)",
    quote: "$1.7 billones es la brecha global de financiamiento para pequeñas y medianas empresas. Sin embargo, en África Subsahariana, el 28% de los jóvenes buscan activamente el emprendimiento—2.3x el promedio global. La brecha no es ambición. Es acceso.",
    fiiWeightDistribution: "Distribución de Peso del FII",
    mentalHealth: "Salud Mental",
    workforceLabel: "Fuerza Laboral",
    entrepreneurshipLabel: "Emprendimiento",
    understandOpportunity: "Entender la oportunidad",
    opportunityTitle: "La Oportunidad de Emprendimiento en Números",
    opportunitySubtitle: "Estadísticas críticas que dan forma al emprendimiento juvenil global",
    opportunity: {
      stat1Label: "brecha global de financiamiento de PYMEs",
      stat2Label: "tasa TEA juvenil en África Subsahariana (2.3x promedio global)",
      stat3Label: "aspiración promedio global de emprendimiento",
      stat4Label: "financiamiento VC para mujeres emprendedoras",
      stat5Label: "total de financiamiento VC para mujeres globalmente",
      stat6Label: "nuevas startups lanzadas anualmente",
      stat7Label: "tasa de fracaso de startups en 5 años",
      stat8Label: "empleos creados por 1% de aumento en emprendimiento",
    },
    severity: {
      barrier: "Barrera",
      opportunity: "Oportunidad",
      gap: "Brecha",
    },
    coreProblem: "El Problema Central",
    coreProblemDesc: "NO es falta de ambición. El emprendimiento es el mecanismo primario de supervivencia en economías con empleo tradicional limitado. En África/ME, el 52% de los jóvenes quieren iniciar negocios—no es un lujo; es la economía del futuro. Las barreras reales: Brecha de capital ($1.7T globalmente), Brecha de habilidades (planificación de negocios, literacía financiera), Brecha de confianza (prestamistas no confían en jóvenes emprendedores), Brecha de infraestructura (carga regulatoria, sistemas de pago), y Brecha de género (mujeres enfrentan 2-3x más barreras).",
    fiiTitle: "Metodología FII de Emprendimiento",
    fiiSubtitle: "Puntuación de Emprendimiento = 25% del Índice de Impacto Futuro",
    subWeight: "sub-peso",
    globalAverage: "Promedio global",
    highest: "Más alto",
    lowest: "Más bajo",
    fii: {
      easeOfBusiness: "Facilidad para Hacer Negocios",
      easeOfBusinessDef: "Entorno regulatorio, fricción para startups, registro de empresas",
      easeHighest: "Singapur, Nueva Zelanda (90+)",
      easeLowest: "Venezuela, Somalia (40-)",
      accessFinancing: "Acceso a Financiamiento",
      accessFinancingDef: "Disponibilidad de capital, acceso a crédito, VC, inversión ángel",
      accessHighest: "EE.UU., Reino Unido (80%+ población)",
      accessLowest: "África Subsahariana (10-20%)",
      tea: "Emprendimiento en Etapa Temprana (TEA)",
      teaDef: "% de población iniciando/gestionando nuevos negocios activamente",
      teaHighest: "África Subsahariana (28%)",
      teaLowest: "Europa (12%)",
      digitalInfra: "Infraestructura Digital",
      digitalInfraDef: "Internet, sistemas de pago, preparación para e-commerce",
      digitalHighest: "Países nórdicos (95%)",
      digitalLowest: "África Subsahariana (20-30%)",
    },
    regionalTitle: "Puntuaciones Regionales de Emprendimiento",
    regionalSubtitle: "Dimensión FII de Emprendimiento: Rendimiento Regional",
    regions: {
      europe: "Europa",
      asiaPacific: "Asia y el Pacífico",
      americas: "América",
      africaMe: "África y Oriente Medio",
    },
    status: {
      strong: "Fuerte",
      growing: "Creciendo",
      mixed: "Mixto",
      emerging: "Emergente",
    },
    regional: {
      europeDrivers: "Soporte regulatorio, acceso a capital, incubadoras",
      europeOpportunity: "Cultura de aversión al riesgo necesita aceleración de innovación",
      asiaPacificDrivers: "Ecosistema de unicornios, apoyo gubernamental, hubs tecnológicos",
      asiaPacificOpportunity: "Ciudades tier-2/3 necesitan acceso a capital",
      americasDrivers: "Norteamérica fuerte (80+), cultura de innovación",
      americasOpportunity: "Latinoamérica necesita democratización de capital",
      africaMeDrivers: "Mayor aspiración (52%), salto digital",
      africaMeOpportunity: "Cierre de brecha de capital severa, conexión con MFI",
    },
    strength: "Fortaleza",
    challenge: "Oportunidad",
    easeScore: "Puntuación de Facilidad",
    financingScore: "Financiamiento",
    teaScore: "Tasa TEA",
    digitalScore: "Digital",
    keyFinding: "Hallazgo Clave",
    keyFindingDesc: "Las puntuaciones de emprendimiento varían solo 12 puntos (Europa 72 vs. África/OM 60) — la MENOR brecha FII. Sin embargo, la aspiración emprendedora es MAYOR en África/OM (52% vs. 35% global). Esto significa que la capacidad existe; solo falta la infraestructura.",
    projectionTitle: "Proyección 2024 vs 2040",
    financingTitle: "La Brecha de Financiamiento de $1.7 Billones",
    financingSubtitle: "Dónde se origina la brecha global de financiamiento de PYMEs y cómo JCI puede ayudar a cerrarla",
    gapByRegion: "Brecha de Financiamiento por Región",
    trillion: "Billones",
    totalGap: "Brecha Total Global de Financiamiento de PYMEs",
    timeline: "Plazo",
    impact: "Impacto",
    financingGapTitle: "La Brecha de Financiamiento de $1.7 Billones",
    financingGapSubtitle: "Dónde se origina la brecha global de financiamiento de PYMEs",
    financingGap: {
      subSaharan: "África Subsahariana",
      subSaharanGap: "$500B+",
      subSaharanCause: "Sin infraestructura formal de crédito, alta percepción de riesgo",
      southAsia: "Sur de Asia",
      southAsiaGap: "$400B+",
      southAsiaCause: "Barreras regulatorias, dominancia de economía informal",
      southeastAsia: "Sudeste Asiático",
      southeastAsiaGap: "$200B+",
      southeastAsiaCause: "Inconsistencia regulatoria, concentración de VC",
      latinAmerica: "América Latina",
      latinAmericaGap: "$300B+",
      latinAmericaCause: "Volatilidad económica, carga regulatoria",
      mena: "Oriente Medio/Norte de África",
      menaGap: "$200B+",
      menaCause: "Mercados de capital limitados, discriminación de género",
    },
    gapMeaning: "Qué Significa Realmente 'Brecha de Financiamiento'",
    gapTypes: {
      awareness: "Brecha de Concienciación",
      awarenessDef: "Emprendedores no saben que existen fuentes de financiamiento",
      access: "Brecha de Acceso",
      accessDef: "Capital concentrado geográfica + demográficamente",
      skills: "Brecha de Habilidades",
      skillsDef: "No pueden escribir propuestas o proyecciones financieras",
      trust: "Brecha de Confianza",
      trustDef: "Prestamistas no confían en jóvenes emprendedores",
      collateral: "Brecha de Garantía",
      collateralDef: "Jóvenes pobres no tienen activos para ofrecer",
      gender: "Brecha de Género",
      genderDef: "Mujeres enfrentan 2-3x más barreras institucionales",
    },
    landscapeTitle: "Panorama Global del Emprendimiento",
    landscapeSubtitle: "Métricas de emprendimiento por región (GEM 2024-25)",
    teaRate: "Tasa TEA",
    businessTypes: "Tipos de Negocios",
    financing: "Financiamiento",
    successRate: "Tasa de Éxito",
    landscape: {
      subSaharanTitle: "África Subsahariana",
      subSaharanTea: "28% TEA (MÁS ALTA globalmente)",
      subSaharanTypes: "70% micro, 25% PYMEs, 5% escalables",
      subSaharanFinancing: "80% autofinanciado/familia; 5% formal",
      subSaharanSuccess: "40% tasa de supervivencia",
      southeastAsiaTitle: "Sudeste Asiático",
      southeastAsiaTea: "20% TEA (fuerte, creciendo)",
      southeastAsiaTypes: "40% digital, 35% retail, 25% manufactura",
      southeastAsiaFinancing: "50% bootstrap, 30% ángel/VC",
      southeastAsiaSuccess: "55% tasa de supervivencia",
      latinAmericaTitle: "América Latina",
      latinAmericaTea: "18% TEA (creciendo)",
      latinAmericaTypes: "60% micro, 30% PYMEs, 10% escalables",
      latinAmericaFinancing: "70% autofinanciado, 20% familia",
      latinAmericaSuccess: "45% tasa de supervivencia",
      europeTitle: "Europa",
      europeTea: "12% TEA (maduro, estable)",
      europeTypes: "20% micro, 30% PYMEs, 50% escalables",
      europeFinancing: "60% institucional, 40% autofinanciado",
      europeSuccess: "65% tasa de supervivencia",
      northAmericaTitle: "Norteamérica",
      northAmericaTea: "15% TEA (liderado por innovación)",
      northAmericaTypes: "10% micro, 20% PYMEs, 70% escalables",
      northAmericaFinancing: "50% VC/ángel, 30% institucional",
      northAmericaSuccess: "70% tasa de supervivencia",
    },
    deepDiveTitle: "Análisis Regionales Profundos",
    deepDiveSubtitle: "Análisis detallado de emprendimiento por región JCI",
    strengths: "Fortalezas",
    challenges: "Desafíos",
    jciOpportunity: "Oportunidad JCI",
    deepDive: {
      europe: {
        strength1: "Infraestructura de clase mundial (claridad regulatoria, sistemas digitales)",
        strength2: "Acceso a capital: €80B+ invertidos en 2024",
        strength3: "Ecosistema maduro de startups: incubadoras, aceleradoras",
        challenge1: "Aversión al riesgo: fracaso estigmatizado",
        challenge2: "Fuga de cerebros a EE.UU./Asia",
        challenge3: "Concentración de capital en Londres, Berlín, París",
        opportunity: "Enfoque en aceleración de innovación, startups de deep tech",
      },
      asiaPacific: {
        strength1: "Ecosistema de unicornios: China 200+, India 80+",
        strength2: "Aceleración gubernamental: billones invertidos",
        strength3: "Dividendo demográfico: 35% menores de 25",
        challenge1: "Desigualdad extrema: riqueza en ciudades tier-1",
        challenge2: "Volatilidad regulatoria",
        challenge3: "Barreras de género: culturales + institucionales",
        opportunity: "Iniciativa de startups tier-2/3, programas de mujeres en tech",
      },
      americas: {
        strength1: "Mayor mercado de VC ($150B+ invertidos en 2024)",
        strength2: "Cultura de innovación: Silicon Valley, NYC, Toronto",
        strength3: "Mercados diversos: tech, biotech, fintech",
        challenge1: "Brecha Norte-Sur de 14 puntos",
        challenge2: "Carga regulatoria de Latinoamérica",
        challenge3: "Solo 2% de startups LAC obtienen VC",
        opportunity: "Puente Norte-Sur para mentoría, capacidad LAC",
      },
      africaMe: {
        strength1: "Mayor aspiración globalmente: 52% quieren negocio",
        strength2: "Población joven: 60% menores de 25",
        strength3: "Salto digital: mobile-first (95%+ tienen teléfonos)",
        challenge1: "Brecha de financiamiento MASIVA: 80% autofinanciado",
        challenge2: "Brechas de habilidades: planificación de negocios, contabilidad",
        challenge3: "Niñas sistemáticamente excluidas",
        opportunity: "Oportunidad de $10T: alcanzar 5% de 1.2B jóvenes → 6M empleos",
      },
    },
    outcomesTitle: "Resultados y Estudios de Caso",
    outcomesSubtitle: "Impacto medible de los programas CYE y emprendimiento de JCI",
    cases: {
      hongKongCountry: "Hong Kong",
      hongKongTitle: "JAPJAP Zero Waste Limited",
      hongKongOutcome: "Residuos alimentarios → proteína + compost usando tecnología AI-IoT. Fundadora mujer, origen inmigrante.",
      hongKongMetric: "100+ toneladas procesadas",
      panamaCountry: "Panamá",
      panamaTitle: "Integra Project Management",
      panamaOutcome: "Eficiencia de cadena de suministro alimentaria para Latinoamérica. 30 nuevos productos, 97% tasa de calidad.",
      panamaMetric: "250 toneladas CO2 reducidas",
      turkeyCountry: "Turquía",
      turkeyTitle: "Grinove Materials",
      turkeyOutcome: "Residuos agrícolas → biomateriales compostables. Científica mujer convertida en emprendedora.",
      turkeyMetric: "Expansión europea planificada",
    },
    actionsTitle: "Acciones Recomendadas para JCI",
    actionsSubtitle: "Prioridades estratégicas para cerrar la brecha de emprendimiento",
    actions: {
      action1Title: "Escalar CYE 10x",
      action1Desc: "Expandir de 108 a 1,000 emprendedores/año, alcanzando 5,000 para 2030",
      action1Effort: "18-24 meses",
      action1Impact: "10x alcance",
      action2Title: "Fondo de Emprendimiento Femenino",
      action2Desc: "Crear fondo de $100M para fundadoras con microfinanzas + mentoría",
      action2Effort: "18 meses",
      action2Impact: "50K mujeres para 2030",
      action3Title: "Alianzas con MFI",
      action3Desc: "Formalizar alianzas con 50 instituciones de microfinanzas",
      action3Effort: "12 meses",
      action3Impact: "500K acceso a crédito",
      action4Title: "Hubs de Incubación JCI",
      action4Desc: "Construir 30 hubs de incubación en África/Asia/LAC",
      action4Effort: "24 meses",
      action4Impact: "10K acelerados",
      action5Title: "Marketplace de Startups",
      action5Desc: "Crear plataforma digital conectando emprendedores con proveedores, clientes, mentores",
      action5Effort: "9-12 meses",
      action5Impact: "100K+ conectados",
      action6Title: "Redes Regionales JIB",
      action6Desc: "Establecer redes de mentoría conectando 5,000+ mentores con fundadores",
      action6Effort: "12 meses",
      action6Impact: "5K+ mentores",
    },
    ctaTitle: "El Emprendimiento Crea Empleos",
    ctaDescription: "Cuando el empleo tradicional es escaso, el emprendimiento se convierte en el PRINCIPAL camino hacia la oportunidad. 1 emprendedor crea 3-5 empleos. Si JCI escala 10x para 2030: 5M empleos creados, $500B+ en valor de negocios globalmente.",
    exploreFII: "Explorar FII",
    exploreWorkforce: "Explorar Fuerza Laboral",
    dataSources: { title: "Fuentes de Datos" },
  },
} as const;

export type EntrepreneurshipTranslations = typeof entrepreneurship;
